import { useEffect, useState } from "react";
import ServiceData from "../DB/ServiceData";
import './ServiceComponentsCSS/ServiceDetails.css';


const renderDialyzerDescription = () => (
    <div className="dialyzer-description" style={{fontSize:"14px",color:"#555"}}>
        <p>
            We provide patients with the option of <strong>single-use</strong> or medically approved <strong>multi-use</strong> dialyzers, allowing them to choose based on comfort, safety, and cost-effectiveness:
        </p>

        <p><strong>Single-use dialyzers</strong></p>
        <ul>
            <li>Offer maximum sterility</li>
            <li>Provide a fresh filter for every session</li>
            <li>Reduce any risk of cross-contamination</li>
        </ul>

        <p><strong>Multi-use dialyzers</strong></p>
        <ul>
            <li>Carefully cleaned and disinfected</li>
            <li>Reused only for the same patient</li>
            <li>Follow strict safety and quality guidelines</li>
        </ul>

        <p>This approach ensures both safety and flexibility while upholding the highest standards of care.</p>
    </div>
);


export default function ServiceDetails({ serviceName }) {
    const [introLength, setIntroLength] = useState(0);

    useEffect(() => {
        if (ServiceData[serviceName]?.intro) {
            setIntroLength(ServiceData[serviceName].intro.length);
        }
    }, [serviceName]);

    const service = ServiceData[serviceName];

    if (!service) {
        return <p>Service not found.</p>;
    }

    return (
        <div className="right-content">
            {/* <h2 className="section-heading">About {serviceName} Tests</h2> */}

            {introLength > 0 && (
                <div className="ServiceIntroSection">
                    <p>{service.intro}</p>
                </div>
            )}

            {service.services.map((test, i) => (
                <section className="test-details-block" key={i}>
                    <div className={`test-content ${i % 2 === 0 ? 'normal' : 'reverse'}`}>
                        <div className="test-text ">
                            <h3 className="test-title rb-headingTag service-headingTag" style={{ color: test.color }}>{test.title}</h3>
                            {test.title === "Dialyzer Choices" ? (
                                renderDialyzerDescription()
                            ) : (
                                <p>{test.description}</p>
                            )}

                        </div>
                        <div className="test-image">
                            <img src={test.image} alt={test.title} />
                        </div>
                    </div>
                </section>
            ))}
        </div>
    );
}
